import React from 'react';
import Stylus from './Stylus';
import assistantStyles from '../components/Assistant/Assistant.module.css';
import classNames from 'classnames';

class StylusAssistantPromo extends Stylus {
  async activate() {
    super.activate();

    await this.controller.actionOpenAssistantPromo();
  }

  renderIcon() {
    return (
      <i
        className={classNames(
          'fa-regular fa-wand-magic-sparkles',
          assistantStyles.assistantWandIcon,
          assistantStyles.assistantWandIconPromo
        )}
      />
    );
  }

  description() {
    return 'assistantpromo';
  }

  isPromotion() {
    return true;
  }
}

export default StylusAssistantPromo;
